import { ColorTokenValue } from 'designSystem/types';
import * as S from './styles';

interface ColorTokenPreviewProps {
	value: ColorTokenValue;
}

export const ColorTokenPreview = ({ value }: ColorTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.ColorSwatch color={value.hex} />
			<S.ValueText>{value.hex}</S.ValueText>
		</S.PreviewContainer>
	);
};
